import React from "react";
import { ImageIcon } from "@radix-ui/react-icons";
import { useMarketing } from "../../providers";
import { RadixButton } from "../primitives/RadixButton";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import "./specialsFlyout.css";
import { formatter } from "../utility/formatter";
import { isAvailableForOrderMode, isCateringOrderMode } from "../utility/cateringMenuAvailability";
var SPECIAL_CTA_LABEL = "Get Started";
var DEFAULT_SPECIAL_IMAGE = "https://d2tiuz65ev218l.cloudfront.net/toppings/generic.svg";
var getRelativeUri = function () {
    var specialsWindow = window;
    return typeof specialsWindow.relativeURI === "function" ? specialsWindow.relativeURI() : "";
};
var navigateToSpecial = function (specialId) {
    document.location.href = "".concat(getRelativeUri(), "/menu/specials/").concat(encodeURIComponent(String(specialId)));
};
var getSpecialDescription = function (special) {
    if (special.description) {
        return special.description;
    }
    if (special.has_overall_discount && special.discount_value > 0) {
        return "".concat(special.discount_type === "target" ? "Only" : "Save", " $").concat(special.discount_value.toFixed(2));
    }
    return "Limited-time special available now.";
};
export var SpecialsFlyout = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var open = _a.open, onOpenChange = _a.onOpenChange;
    var _k = useMarketing(), specials = _k.specials, isLoadingSpecials = _k.isLoadingSpecials, specialsError = _k.specialsError;
    var specialsWindow = window;
    var isCateringOrder = isCateringOrderMode((_c = (_b = specialsWindow.session) === null || _b === void 0 ? void 0 : _b.store) === null || _c === void 0 ? void 0 : _c.is_catering);
    var availableSpecials = specials.filter(function (special) {
        return isAvailableForOrderMode(special.catering_menu_availability, isCateringOrder);
    });
    var SPECIAL_NAME = (_f = (_e = (_d = specialsWindow.session) === null || _d === void 0 ? void 0 : _d.store_branding) === null || _e === void 0 ? void 0 : _e.special_name_plural) !== null && _f !== void 0 ? _f : "deals";
    var SPECIAL_NAME_SINGLE = (_j = (_h = (_g = specialsWindow.session) === null || _g === void 0 ? void 0 : _g.store_branding) === null || _h === void 0 ? void 0 : _h.special_name) !== null && _j !== void 0 ? _j : "deal";
    return (React.createElement(RadixFlyOut, { open: open, onOpenChange: onOpenChange, title: SPECIAL_NAME, description: formatter.toProperCase("Browse Today's Available ".concat(SPECIAL_NAME, ".")) },
        React.createElement("section", { className: "specials-flyout", "aria-live": "polite" },
            isLoadingSpecials ? (React.createElement("p", { className: "specials-flyout__status" },
                "Loading ",
                SPECIAL_NAME,
                "\u2026")) : null,
            !isLoadingSpecials && specialsError ? (React.createElement("p", { className: "specials-flyout__status specials-flyout__status--error" }, specialsError)) : null,
            !isLoadingSpecials && !specialsError && availableSpecials.length === 0 ? (React.createElement("p", { className: "specials-flyout__status" },
                "No ",
                SPECIAL_NAME,
                " are available right now.")) : null,
            !isLoadingSpecials && !specialsError && availableSpecials.length > 0 ? (React.createElement("ul", { className: "specials-flyout__list", "aria-label": "Available ".concat(SPECIAL_NAME) }, availableSpecials.map(function (special) {
                var imageSrc = special.imageURL || DEFAULT_SPECIAL_IMAGE;
                var isPlaceholderImage = imageSrc === DEFAULT_SPECIAL_IMAGE;
                return (React.createElement("li", { key: special.id, className: "specials-flyout__item" },
                    React.createElement("article", { className: "specials-flyout__card" },
                        React.createElement("div", { className: "specials-flyout__image-wrap" },
                            React.createElement("img", { className: "specials-flyout__image", src: imageSrc, alt: "".concat(special.name, " ").concat(SPECIAL_NAME_SINGLE), onError: function (event) {
                                    event.currentTarget.src = DEFAULT_SPECIAL_IMAGE;
                                } }),
                            isPlaceholderImage ? (React.createElement("span", { className: "specials-flyout__image-badge", "aria-hidden": "true" },
                                React.createElement(ImageIcon, null))) : null),
                        React.createElement("div", { className: "specials-flyout__content" },
                            React.createElement("div", { className: "specials-flyout__text" },
                                React.createElement("h3", { className: "specials-flyout__title" }, special.name),
                                React.createElement("p", { className: "specials-flyout__description" }, getSpecialDescription(special))),
                            React.createElement(RadixButton, { type: "button", className: "specials-flyout__button", onClick: function () { return navigateToSpecial(special.id); }, "aria-label": "".concat(SPECIAL_CTA_LABEL, " with ").concat(special.name) }, SPECIAL_CTA_LABEL)))));
            }))) : null)));
};
